import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Animate, AnimateKeyframes, AnimateGroup } from 'react-simple-animate';
import Uniform from './uniform.jsx';
import DatePicker from 'react-datepicker';
import moment from 'moment';
export default class ThisDriversArchivedUniforms extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      url: props.url || '/api/v1/portal/drivers/uniforms',
      uniformAccountId: props.uniformAccountId || null,
      uniforms: [],
    };
    this.handleUniformsTableRefresh = this.handleUniformsTableRefresh.bind(this);
    this.handleUniformsTableRefresharc = this.handleUniformsTableRefresharc.bind(this);
    this.editModalManage = this.editModalManage.bind(this);
    this.handleCallParentMethod = this.handleCallParentMethod.bind(this);
  }

  componentDidMount() {
    var that = this;
    $.ajax({
      url: '/api/v1/portal/drivers/uniforms/'+
      this.state.uniformAccountId+'/archived',
      method: 'GET',
      data: {api_token: window.api_token},
      cache: false
    })
    .done(function(uniformsJson) {
      that.setState({
        uniforms: uniformsJson,
        isLoading: false
      });
    });
  }
  handleUniformsTableRefresh(){
    var that = this;
    $.ajax({
      url: '/api/v1/portal/drivers/uniforms/'+this.state.uniformAccountId+'/current',
      method: 'GET',
      data: {api_token: window.api_token},
      cache: false
    })
    .done(function(uniformsJson) {
      that.setState({
        uniforms: uniformsJson,
        isLoading: false
      });
    });
  }
  handleUniformsTableRefresharc(){
    var that = this;
    $.ajax({
      url: '/api/v1/portal/drivers/uniforms/'+
      this.state.uniformAccountId+'/archived',
      method: 'GET',
      data: {api_token: window.api_token},
      cache: false
    })
    .done(function(uniformsJson) {
      that.setState({
        uniforms: uniformsJson,
        isLoading: false
      });
    });
  }
  editModalManage(editId){
    $('#'+editId+'-edit-row').toggleClass('toggle-hide');
  }
  handleCallParentMethod(total, paid_total){
    this.props.handleTotalAmountUpdate(total);
    this.props.handlePaidAmountUpdate(paid_total);
  }

  render() {
    var Uniforms = [];
    let editModalManage = this.editModalManage;
      let handleUniformsTableRefresh = this.handleUniformsTableRefresh;
      let handleUniformsTableRefresharc = this.handleUniformsTableRefresharc;
      let handleCallParentMethod = this.handleCallParentMethod;

    if (this.state.uniforms.length > 0) {
        this.state.uniforms.forEach(function(i,index) {
            Uniforms.push(<Uniform key={'uniform-'+i.id} data={i} 
                  handleUniformsTableRefresh={handleUniformsTableRefresh}
                  editModalManage={editModalManage} 
                  handleCallParentMethod={handleCallParentMethod} />);
            Uniforms.push(
              <tr id={i.id+"-edit-row"} key={'uniform-'+index} className="toggle-hide">
                <td colSpan="8"> 
                  <EditModal data={i} 
                  handleUniformsTableRefresh={handleUniformsTableRefresh}
                  handleUniformsTableRefresharc={handleUniformsTableRefresharc}
                  editModalManage={editModalManage} 
                  handleCallParentMethod={handleCallParentMethod}/>
                </td>
              </tr>
            );
          });
        }
    return (
        <div>
            <div className="row uniforms-table-header">
                <table className="driver-wages-table"> 
                  <thead>
                    <tr className="uniforms-table-header">
                      <th>description</th>
                      <th>ref</th>
                      <th>amounts</th>
                      <th>frequency</th>
                      <th>StartDate</th>
                      <th>EndDate</th>
                      <th>Edit</th>
                      <th>Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Uniforms}
                  </tbody>
              </table>
            </div>
        </div>
    );
  }
}

class EditModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      data: props.data || null,
    };
    this.handleStartDateChange = this.handleStartDateChange.bind(this);
    this.handleEndDateChange = this.handleEndDateChange.bind(this);
    this.handleDeductionOccurance = this.handleDeductionOccurance.bind(this);
  }
  handleStartDateChange(date) {
    this.state.data.start_date = date;
    this.setState({data: this.state.data});
  }
  handleEndDateChange(date) {
    this.state.data.end_date = date;
    this.setState({data: this.state.data});
  }
  handleDeductionOccurance(e){
    this.state.data.deduction_occurance =  e.target.value;
    this.setState({data: this.state.data});
  }
  handleDescChange(e){
    this.state.data.description =  e.target.value;
    this.setState({data: this.state.data});
  }
  handleRefChange(e){
    this.state.data.insurance_reference =  e.target.value;
    this.setState({data: this.state.data});
  }
  handleOriginalAmountChange(e){
    this.state.data.original_amount_to_repay =  e.target.value;
    this.setState({data: this.state.data});
  }
  handleAgreedAmountChange(e){
    this.state.data.agreed_deduction_amount =  e.target.value;
    this.setState({data: this.state.data});
  }
  handleEditFormSubmitButtonClick(e){
    e.preventDefault();
    let that = this;
    this.setState({isLoading:true});
    let editData = {
      api_token: window.api_token,
      driver_id: this.state.data.driver_id,
      id:this.state.data.id,
      description: this.state.data.description,
      insurance_reference: this.state.data.insurance_reference,
      original_amount_to_repay: this.state.data.original_amount_to_repay,
      deduction_occurance: this.state.data.deduction_occurance,
      agreed_deduction_amount: this.state.data.agreed_deduction_amount,
      start_date: (this.state.data.start_date != null) ? moment(this.state.data.start_date).format("YYYY-MM-DD") : null,
      end_date: (this.state.data.end_date != null) ? moment(this.state.data.end_date).format("YYYY-MM-DD") : null,
    };
    $.ajax({
      type: "POST",
      url: '/api/v1/portal/drivers/uniforms/edit-uniform',
      data: editData,
      dataType: "text/json",
      complete: function(response) {
        that.setState({isLoading:false});
        if (response.status == 200) {
          $('#infomodallabel').html('Uniform');
          $('#infomodal .modal-body').html('Uniform has been updated sucessfully..');
          $('#infomodal').modal();
          that.props.handleUniformsTableRefresharc();
          that.props.handleUniformsTableRefresh();
          that.props.editModalManage(that.state.data.id);
          let txt = JSON.parse(response.responseText)
          that.props.handleCallParentMethod(txt.total, txt.total_paid);
        }
        else {
          $('#infomodallabel').html('Error updating Uniform');
          $('#infomodal .modal-body').html($.parseHTML(
            response.responseText.
            replace(/\"/g, ""))
          );
          $('#infomodal').modal();
        }
      }
    });
    return false;
  }
  render() {
    return (
      
        <fieldset>
          <div className="row">
            <div className="col-md-6 text-right">Description</div>
            <div className="col-md-6 text-left">
              <input
                className="form-control form-control-lg"
                name="description"
                type="text" placeholder="description" 
                value={this.state.data.description}
                onChange={(e)=>this.handleDescChange(e)}/>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 text-right">Reference</div>
            <div className="col-md-6 text-left">
              <input
              className="form-control form-control-lg"
              name="insurance_reference"
              type="text" placeholder="reference"
              value={this.state.data.insurance_reference} 
              onChange={(e)=>this.handleRefChange(e)}/>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 text-right">Amount to Repay:</div>
            <div className="col-md-6 text-left">
              <input
                className="form-control form-control-lg"
                name="original_amount_to_repay"
                type="text" placeholder="&pound; original amount to repay"
                value={this.state.data.original_amount_to_repay}
                onChange={(e)=>this.handleOriginalAmountChange(e)} />
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 text-right">@</div>
            <div className="col-md-6 text-left">
              <input type="text" placeholder="&pound;agreed deduction amount"
              name="agreed_deduction_amount" id="agreed_deduction_amount"
              className="form-control"
              value={this.state.data.agreed_deduction_amount}
              onChange={(e)=>this.handleAgreedAmountChange(e)} />
            per <select name="deduction_occurance" value={this.state.data.deduction_occurance} id="deduction_occurance" onChange={this.handleDeductionOccurance}>
              <option value="weekly">Week</option>
              <option value="monthly">Month</option>
              <option value="daily">Day</option>
              <option value="hourly">Hour</option>
            </select><br />
          </div>
        </div>
        <div className="weekly">
          <div className="row">
            <div className="col-md-6 text-right">Start Date:</div>
            <div className="col-md-6 text-left">
                <DatePicker todayButton={"Today"} dateFormat="dd-MM-yyyy" onChange={this.handleStartDateChange} 
                selected={(this.state.data.start_date) ? moment(this.state.data.start_date).toDate() : null}/>
          </div>
          </div>
          <div className="row">
            <div className="col-md-6 text-right">End Date:</div>
            <div className="col-md-6 text-left">
                <DatePicker todayButton={"Today"} dateFormat="dd-MM-yyyy" onChange={this.handleEndDateChange} 
                selected={(this.state.data.end_date) ? moment(this.state.data.end_date).toDate() : null }/>
            </div>
          </div>
        </div> 
        <div className="row">
            <div className="col-md-6 text-right">&nbsp;</div>
            <div className="col-md-6 text-left">
            <button className="btn btn-sm btn-primary" disabled={(this.state.isLoading) ? true : false}
              onClick={(e) => {
                this.handleEditFormSubmitButtonClick(e)
              }}>
              <i className="fa fa-plus"></i> Save Uniform</button>
            </div>
            <br/>
        </div>
      </fieldset>
    
    );
  }

}